// B4 · Quality tab helpers: score colours (same bands as Lighthouse), labels, small presentational pieces.
export const CATEGORY = {
  seo: "SEO",
  performance: "Prestazioni",
  accessibility: "Accessibilità",
  "best-practices": "Best practice",
  content: "Contenuti e obblighi",
};

export const LEVEL = {
  error: ["Errori bloccanti", "Bloccano la pubblicazione online finché non li correggi.", "border-red-200 bg-red-50/60", "text-red-700"],
  warning: ["Da confermare", "Prima di pubblicare online ti viene chiesto di confermarli.", "border-amber-200 bg-amber-50/60", "text-amber-800"],
  advice: ["Consigli", "Non bloccano nulla: migliorano punteggio ed esperienza.", "border-slate-200 bg-slate-50", "text-slate-700"],
};

export const tone = (v) => (v == null ? "slate" : v >= 90 ? "emerald" : v >= 50 ? "amber" : "red");
const STROKE = { emerald: "#059669", amber: "#d97706", red: "#dc2626", slate: "#94a3b8" };
const TEXT = { emerald: "text-emerald-700", amber: "text-amber-700", red: "text-red-700", slate: "text-slate-500" };

export function ScoreRing({ value, size = 64, testid }) {
  const r = size / 2 - 5;
  const c = 2 * Math.PI * r;
  const t = tone(value);
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }} data-testid={testid}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#e2e8f0" strokeWidth="5" />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={STROKE[t]} strokeWidth="5" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={c * (1 - (value || 0) / 100)} style={{ transition: "stroke-dashoffset .8s ease" }} />
      </svg>
      <span className={`absolute inset-0 flex items-center justify-center font-semibold tabular-nums ${TEXT[t]} ${size > 50 ? "text-lg" : "text-xs"}`}>{value ?? "—"}</span>
    </div>
  );
}

export const ms = (v) => (v == null ? "—" : v >= 1000 ? `${(v / 1000).toFixed(1).replace(".", ",")} s` : `${Math.round(v)} ms`);
